import { render } from "./PsLabelHeader6.vue?vue&type=template&id=0563ef56&ts=true"
import script from "./PsLabelHeader6.vue?vue&type=script&lang=ts"
export * from "./PsLabelHeader6.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__